import React, { Fragment } from 'react';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.jpeg'





const TermsPage = () => {
    return (
        <Fragment>
            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                            col2={'col-lg-2 col-md-4 col-6'}
                            col3={'col-lg-7 col-md-1 col-1'}
                            col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle pageTitle={''} pagesub={'Terms & Conditions'} />
            <ScrollTextAnimation />
            <section className="pf-terms-section section-padding pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pf-terms-wrap">
                                {/* <div className="pf-terms-img">
                                    <img src={Privci1} alt="" />
                                </div> */}
                                <div className="pf-terms-text">
    <h2>Terms & Conditions</h2>

    <p>
        Welcome to <strong>YV Reddy Associates</strong>. By accessing and using this website, you
        agree to comply with and be bound by the following Terms and Conditions. These terms govern
        your use of our website, services, and all content provided herein. If you do not agree
        with any part of these terms, please discontinue use of the website immediately.
    </p>

    <h3>About YV Reddy Associates</h3>
    <p>
        YV Reddy Associates is a professional architectural, interior design, and turnkey
        contracting firm delivering corporate, commercial, institutional, and residential projects
        across India. All information presented on this website is intended to provide general
        insight into our services, expertise, and completed works.
    </p>

    <h3>Use of Website</h3>
    <p>
        The content on this website is for general informational purposes only. You agree to use
        this website lawfully and not engage in any activity that may harm, disrupt, or interfere
        with its operation.
    </p>

    <ul>
        <li>Unauthorized use of this website may give rise to a claim for damages.</li>
        <li>You must not misuse, hack, or attempt to gain unauthorized access to the website.</li>
        <li>All content must be used only for personal or professional reference.</li>
    </ul>

    <h3>Intellectual Property Rights</h3>
    <p>
        All architectural drawings, designs, layouts, images, text, logos, graphics, and project
        details displayed on this website are the intellectual property of YV Reddy Associates
        unless otherwise stated.
    </p>

    <p>
        No material from this website may be copied, reproduced, modified, distributed, or
        republished in any form without prior written consent from YV Reddy Associates.
    </p>

    <h3>Design & Professional Disclaimer</h3>
    <p>
        Any conceptual designs, images, drawings, or visual representations displayed on this
        website are indicative in nature. Actual project execution may vary based on site
        conditions, client requirements, statutory approvals, materials, and execution methods.
    </p>

    <p>
        The website content does not constitute professional advice or a binding contractual
        commitment unless explicitly stated in a written agreement.
    </p>

    <h3>Project Information & Timelines</h3>
    <p>
        Project timelines, cost estimates, and specifications mentioned on the website are
        indicative and subject to change. Final scope, deliverables, and schedules shall be defined
        only through mutually agreed written contracts.
    </p>

    <h3>Third-Party Links</h3>
    <p>
        This website may contain links to third-party websites for convenience or reference. YV
        Reddy Associates does not endorse or take responsibility for the content, privacy policies,
        or practices of such external websites.
    </p>

    <h3>Limitation of Liability</h3>
    <p>
        YV Reddy Associates shall not be liable for any direct, indirect, incidental, consequential,
        or special damages arising from the use of or inability to use this website, including but
        not limited to loss of data, loss of business, or project delays.
    </p>

    <h3>Confidentiality</h3>
    <p>
        Any information shared by clients for consultation, design, or execution purposes shall be
        treated as confidential and used strictly for project-related activities, unless disclosure
        is required by law or authorized by the client.
    </p>

    <h3>User Submissions</h3>
    <p>
        Any information, documents, drawings, or materials submitted through enquiry forms or
        communication channels must be accurate and lawful. You confirm that you have the right to
        share such information.
    </p>

    <h3>Termination of Access</h3>
    <p>
        YV Reddy Associates reserves the right to restrict, suspend, or terminate access to the
        website at any time without prior notice if these Terms & Conditions are violated.
    </p>

    <h3>Governing Law</h3>
    <p>
        These Terms & Conditions shall be governed by and interpreted in accordance with the laws
        of India. Any disputes arising from the use of this website shall be subject to the
        jurisdiction of Indian courts.
    </p>

    <h3>Changes to Terms</h3>
    <p>
        YV Reddy Associates reserves the right to update or modify these Terms & Conditions at any
        time. Continued use of the website after such changes constitutes acceptance of the updated
        terms.
    </p>

    <h3>Contact Information</h3>
    <p>
        For any questions regarding these Terms & Conditions, please contact YV Reddy Associates
        through the official contact details provided on this website.
    </p>
</div>

                                {/* <div className="pf-faq-section">
                                    <h4>Frequently Ask Questions</h4>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <FAQAccordion/>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar /> 
        </Fragment>
    )
};
export default TermsPage;





